module.exports = __webpack_public_path__ + "media/31.f301a409.mp3";